module.exports = __webpack_public_path__ + "static/media/30-15.b8ccd69b.mp3";